import { render } from "./homefooter.vue?vue&type=template&id=e3c6f0ca&scoped=true"
import script from "./homefooter.vue?vue&type=script&lang=js"
export * from "./homefooter.vue?vue&type=script&lang=js"

import "./homefooter.vue?vue&type=style&index=0&id=e3c6f0ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3c6f0ca"]])

export default __exports__